import { backendFetch } from '@/common/api';
import { UserData } from '@/portal/types/UserData.ts';

export async function loadUsers(): Promise<UserData[]> {
  return backendFetch<UserData[]>('/portal/users', {
    credentials: 'include',
  });
}
